module.exports = __webpack_public_path__ + "static/media/Wolf-01.fb9b4247.png";